import { EditAllTranslationLoacalesDto } from '@routellers/types/dist/translation/edit-all-translation-loacales.dto';

import { ApiMethodDeclaration } from '..';

type ParamsData = {
    id: number;
    data: EditAllTranslationLoacalesDto;
};

type ResponseData = any;

export const updateContext: ApiMethodDeclaration<ParamsData, ResponseData> = ({ id, data }) => ({
    url: `/translations/translation/${id}`,
    method: 'PATCH',
    data,
});
